import React, { useCallback, useMemo } from 'react';
import { StyleSheet, View } from 'react-native';
import Modal from 'utils/packages/Modal';
import Spacer from 'design-system/Spacer';
import Button from 'design-system/Button';
import { rem } from 'design-system/values';
import CorporateEventFilterRow from './CorporateEventFilterRow';
export const CorporateEventsFilterModalContent = ({ onSetFilter, initialState, }) => {
    const [state, setState] = React.useState(initialState);
    const handleSave = useCallback(() => {
        Modal.hide();
        onSetFilter(state);
    }, [onSetFilter, state]);
    const handlePress = useCallback((event) => () => {
        setState((oldState) => ({
            ...oldState,
            [event]: !oldState[event],
        }));
    }, []);
    const isDisabled = useMemo(() => !Object.values(state).find((val) => val), [state]);
    return (<View>
      <Spacer h={8}/>
      <CorporateEventFilterRow selected={state.EX_DIVIDEND} type="EX_DIVIDEND" onPress={handlePress('EX_DIVIDEND')}/>
      <CorporateEventFilterRow selected={state.DIVIDEND} type="DIVIDEND" onPress={handlePress('DIVIDEND')}/>
      <CorporateEventFilterRow selected={state.SPLIT} type="SPLIT" onPress={handlePress('SPLIT')}/>
      <CorporateEventFilterRow selected={state.MERGER} type="MERGER" onPress={handlePress('MERGER')}/>
      <CorporateEventFilterRow selected={state.HOLIDAY} type="HOLIDAY" onPress={handlePress('HOLIDAY')}/>
      <CorporateEventFilterRow selected={state.SYMBOL_CHANGE} type="SYMBOL_CHANGE" onPress={handlePress('SYMBOL_CHANGE')}/>
      <CorporateEventFilterRow type="LISTING_CHANGE" selected={state.LISTING_CHANGE} onPress={handlePress('LISTING_CHANGE')}/>
      <Spacer h={8}/>
      <View style={styles.btnContainer}>
        <Button brand title="Apply" onPress={handleSave} disabled={isDisabled}/>
      </View>
    </View>);
};
const CorporateEventsFilterModal = {
    show: (state, onSetFilter) => {
        Modal.show(<CorporateEventsFilterModalContent initialState={state} onSetFilter={onSetFilter}/>, {
            title: 'Filter',
            containerStyle: styles.modal,
        });
    },
    hide: () => {
        Modal.hide();
    },
};
const styles = StyleSheet.create({
    modal: {
        paddingHorizontal: 0,
        overflow: 'hidden',
    },
    btnContainer: {
        paddingHorizontal: rem(16),
    },
});
export default CorporateEventsFilterModal;
